import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useLanguage } from "@/contexts/LanguageContext";
import { BarControl } from "./BarControl";
import type { BackgroundColorControlProps } from "./types";

export function BackgroundColorControl({
  backgroundColor,
  onBackgroundColorChange,
}: BackgroundColorControlProps) {
  const { t } = useLanguage();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <BarControl>
          <div
            className={cn(
              "w-4 h-4 rounded border",
              backgroundColor === "gray"
                ? "bg-gray-300 border-gray-400"
                : "bg-white border-gray-300",
            )}
          />
          <span className="text-white font-bold text-xs">
            {backgroundColor === "gray"
              ? t.generate.darkGray
              : t.generate.white}
          </span>
          <ChevronDown className="w-3 h-3 text-white/60" />
        </BarControl>
      </PopoverTrigger>
      <PopoverContent align="center" className="w-48 p-3 z-[60]">
        <p className="text-xs font-medium text-muted-foreground mb-2">
          {t.generate.backgroundColor}
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => onBackgroundColorChange("gray")}
            className={cn(
              "flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all",
              backgroundColor === "gray"
                ? "bg-primary text-primary-foreground"
                : "bg-secondary border border-border hover:bg-muted",
            )}
          >
            <div className="w-4 h-4 rounded bg-gray-500 border border-gray-600" />
            <span>{t.generate.darkGray}</span>
          </button>
          <button
            onClick={() => onBackgroundColorChange("white")}
            className={cn(
              "flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all",
              backgroundColor === "white"
                ? "bg-primary text-primary-foreground"
                : "bg-secondary border border-border hover:bg-muted",
            )}
          >
            <div className="w-4 h-4 rounded bg-white border border-gray-300" />
            <span>{t.generate.white}</span>
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
